import { all } from 'redux-saga/effects';
import paymentForJobSaga from './job';
import payPackageSaga from './purchase-package';
import searchFeeSaga from './search-fee';

export const paymentSagas = function* root() {
  yield all([searchFeeSaga(), payPackageSaga(), paymentForJobSaga()]);
};
